// extracted by mini-css-extract-plugin
export default {"Legend":"Fieldset_Legend__v7Rm3"};